const getTintVariantColor = (color1, color2, weight) => {
	const hexToRgb = (hex) => {
		const r = parseInt(hex.slice(1, 3), 16);
		const g = parseInt(hex.slice(3, 5), 16);
		const b = parseInt(hex.slice(5, 7), 16);

		return [r, g, b];
	};

	const rgbToHex = (rgb) => {
		return '#' + ((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1);
	};

	const p = weight;
	const w = p * 2 - 1;
	const w1 = (w / 1 + 1) / 2;
	const w2 = 1 - w1;

	const rgb1 = hexToRgb(color1);
	const rgb2 = hexToRgb(color2);

	const rgb = [
		Math.round(rgb1[0] * w1 + rgb2[0] * w2),
		Math.round(rgb1[1] * w1 + rgb2[1] * w2),
		Math.round(rgb1[2] * w1 + rgb2[2] * w2)
	];

	return rgbToHex(rgb);
};
const hexToRgb = (hex) => {
	const r = parseInt(hex.slice(1, 3), 16);
	const g = parseInt(hex.slice(3, 5), 16);
	const b = parseInt(hex.slice(5, 7), 16);

	return [r, g, b];
};

/**
 * @typedef {{
 *   '50': string,
 *     '100': string,
 *     '200': string,
 *     '300': string,
 *     '400': string,
 *     '500': string,
 *     '600': string,
 *     '700': string,
 *     '800': string,
 *     '900': string
 * }} ColorSteps
 */

/**
 * @param color
 * @param steps
 * @param secondColor
 * @returns {ColorSteps}
 */
export const generateColorSteps = (color, steps = 9, secondColor = '#ffffff') => {
	/*
		50: getTintVariantColor(PRIMARY_COLOR, '#ffffff', 0.05),
		100: getTintVariantColor(PRIMARY_COLOR, '#ffffff', 0.10),
		200: getTintVariantColor(PRIMARY_COLOR, '#ffffff', 0.20),
		300: getTintVariantColor(PRIMARY_COLOR, '#ffffff', 0.30),
		400: getTintVariantColor(PRIMARY_COLOR, '#ffffff', 0.40),
		500: getTintVariantColor(PRIMARY_COLOR, '#ffffff', 0.50)
	 */

	const colorSteps = {};
	colorSteps[50] = getTintVariantColor(color, secondColor, 0.05);
	for (let i = 1; i <= steps; i++)
	{
		colorSteps[i * 100] = getTintVariantColor(color, secondColor, i / steps);
	}

	return colorSteps;
};
export { hexToRgb };
export { getTintVariantColor };